/* unplugin-vue-components disabled */import { render } from "./bmb.vue?vue&type=template&id=66de08fc&scoped=true"
import script from "./bmb.vue?vue&type=script&lang=js"
export * from "./bmb.vue?vue&type=script&lang=js"

import "./bmb.vue?vue&type=style&index=0&id=66de08fc&lang=less&scoped=true"

import exportComponent from "D:\\云盘\\SynologyDrive\\Synology Drive\\文件\\客户调查表\\customweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66de08fc"]])

export default __exports__